import React from 'react';
import { Headphones } from 'lucide-react';

const episodiosPrevia = [
  { titulo: 'Ep. 1 – Entrevista com Marcos Suzano' },
  { titulo: 'Ep. 2 – Entrevista com Clarice Magalhães' },
  { titulo: 'Ep. 3 – Entrevista com Netinho Albuquerque' },
];

export const PodcastPage: React.FC = () => {
  return (
    <div className="container pt-28 pb-16 md:pt-32 md:pb-20 max-w-3xl mx-auto">
      <div className="text-center mb-12">
        <Headphones className="w-12 h-12 text-accent mx-auto mb-4" />
        <h1 className="text-3xl md:text-4xl text-primary mb-3">Podcast Casa do Pandeiro</h1>
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent/15 text-accent text-sm font-medium">
          Em breve
        </span>
      </div>

      <p className="text-muted-foreground leading-relaxed text-center max-w-xl mx-auto mb-12">
        O podcast da Casa do Pandeiro vai falar de pandeiro, música brasileira, histórias de mestres,
        prática, tradição e inovação. Conversas com músicos, educadores e amantes do pandeiro.
      </p>

      <div className="space-y-4 mb-12">
        <h2 className="text-xl text-primary mb-4">Prévia de episódios</h2>
        {episodiosPrevia.map((ep) => (
          <div key={ep.titulo} className="p-5 bg-card rounded-lg border">
            <h3 className="font-semibold text-foreground">{ep.titulo}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};
